/** Invalid dates (empty or unparseable) go last ascending and first descending, or always last with `always-end`. */
export function compareByDate<T>(
    dateExtractor: (item: T) => string,
    opts: {
        type: 'ascending' | 'descending';
        invalidDatesPlacement?: 'contextual' | 'always-end';
    } = { type: 'descending', invalidDatesPlacement: 'contextual' },
): (a: T, b: T) => number {
    return (a: T, b: T): number => {
        const aDate = dateExtractor(a);
        const bDate = dateExtractor(b);

        const aTimeStamp = new Date(aDate).getTime();
        const bTimeStamp = new Date(bDate).getTime();

        const isAscending = opts.type === 'ascending';
        const alwaysPlaceInvalidAtEnd = opts.invalidDatesPlacement === 'always-end';

        const aIsInvalid = aDate == null || aDate === '' || !isFinite(aTimeStamp);
        const bIsInvalid = bDate == null || bDate === '' || !isFinite(bTimeStamp);

        if (aIsInvalid && bIsInvalid) {
            return 0;
        }
        if (aIsInvalid) {
            return alwaysPlaceInvalidAtEnd ? 1 : isAscending ? 1 : -1;
        }
        if (bIsInvalid) {
            return alwaysPlaceInvalidAtEnd ? -1 : isAscending ? -1 : 1;
        }

        const result = aTimeStamp - bTimeStamp;
        if (isAscending) {
            return result;
        }
        return -result;
    };
}
